import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { GlobalVarsService } from '../services/global-vars.service';

@Component({
  selector: 'app-agree',
  templateUrl: './agree.component.html',
  styleUrls: ['./agree.component.scss']
})
export class AgreeComponent implements OnInit {

	private isAgreeOk: boolean;

  constructor(private globalVarsService: GlobalVarsService,
  						private router: Router) { }

  ngOnInit() {
  	this.getAgreeState();
  }

  private getAgreeState() {
		this.globalVarsService.getAgreeState().subscribe(data => setTimeout(() => {
		  //console.log('subscribe', data);
		  this.isAgreeOk = data;
		})); 
  };

  private setAgreeState() {
  	if(this.isAgreeOk) {
  		this.globalVarsService.setAgreeState(true);
  		this.router.navigate(['/main']); 		
  	}
  };
}



// WEBPACK FOOTER //
// /home/kalinin/angular2/PRACTICE/feedback/src/app/agree/agree.component.ts